<template>
  <div id="produk">
    <!-- <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="white">
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <a @click="goTo('/')" class="font-weight-light">Smart247</a>
        <span>.id</span>
      </v-toolbar-title>
      <v-text-field
        flat
        v-model="pencarian"
        solo-inverted
        hide-details
        v-on:keyup.13="find()"
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
      />
      <v-spacer />
      <div class="mx-5">
        <v-badge :content="cartLength" :value="cartLength" color="green" overlap>
          <v-icon @click="goTo('/cart')" size="30">fas fa-shopping-cart</v-icon>
        </v-badge>
      </div>
    </v-app-bar>-->
    <v-toolbar dark color="#FF6F00">
      <!-- <v-toolbar-title>Smart247</v-toolbar-title> -->
      <a href="/">
        <v-img
          src="http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/smartclub247_512x512"
          height="100"
          width="200"
        ></v-img>
      </a>

      <v-spacer></v-spacer>
      <v-text-field
        flat
        v-model="pencarian"
        solo-inverted
        hide-details
        v-on:keyup.13="find()"
        prepend-inner-icon="mdi-magnify"
        label="Search"
        class="hidden-sm-and-down"
      />
      <v-btn @click="goTo('/cart')" style="float:right;" dark icon>
        <!-- <v-icon size="20">fas fa-shopping-cart</v-icon> -->
        <v-badge :content="cartHeader" bordered :value="cartHeader" color="green" overlap>
          <v-icon size="25">fas fa-shopping-cart</v-icon>
        </v-badge>
      </v-btn>
      <v-btn @click="goTo('/wishlist')" style="float:right;" dark icon>
        <v-icon size="25">fas fa-heart</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- NAVIGATION DRAWER -->
    <v-flex xs12 md12 lg12>
      <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="2">
          <v-card width="256" class="mx-5 my-5">
            <v-navigation-drawer permanent>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title">
                    <v-row v-if="token == null">
                      <v-col>
                        <v-btn @click="goTo('/login')" outlined block>Login</v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="token != null">
                      <v-col cols="3">
                        <v-avatar class="my-auto" color="indigo">
                          <v-icon dark>mdi-account-circle</v-icon>
                        </v-avatar>
                      </v-col>
                      <v-col cols="8">
                        <div v-if="token !=null">
                          <span class="nama-user">{{ dataUser.nama }}</span>
                          <div class="verified-user">
                            <v-chip class="mt-3" x-small color="pink" label text-color="white">
                              <v-icon x-small left>fas fa-check</v-icon>Verified
                            </v-chip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <v-list shaped>
                <v-subheader>KATEGORI</v-subheader>
                <v-list-item-group v-model="items.page" color="primary">
                  <v-list-item @click="show(item.page)" v-for="(item, i) in items" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-navigation-drawer>
          </v-card>
          <!-- NAVIGATION DRAWER -->
        </v-col>
        <v-col cols="7">
          <div>
            <v-chip v-if="page == 1" class="ma-2" color="cyan" label text-color="white">
              Rumah Tangga
              <v-icon @click="page = 0" class="mx-1" small>mdi-close</v-icon>
            </v-chip>
            <v-chip v-if="page == 2" class="ma-2" color="cyan" label text-color="white">
              Fashion
              <v-icon @click="page = 0" class="mx-1" small>mdi-close</v-icon>
            </v-chip>
            <v-chip v-if="page == 3" class="ma-2" color="cyan" label text-color="white">
              Elektronik
              <v-icon @click="page = 0" class="mx-1" small>mdi-close</v-icon>
            </v-chip>
            <v-chip v-if="page == 4" class="ma-2" color="cyan" label text-color="white">
              Gadget
              <v-icon @click="page = 0" class="mx-1" small>mdi-close</v-icon>
            </v-chip>
            <v-chip v-if="page == 5" class="ma-2" color="cyan" label text-color="white">
              Mainan
              <v-icon @click="page = 0" class="mx-1" small>mdi-close</v-icon>
            </v-chip>
            <v-chip v-if="page == 6" class="ma-2" color="cyan" label text-color="white">
              Babies
              <v-icon @click="page = 0" class="mx-1" small>mdi-close</v-icon>
            </v-chip>
          </div>
          <All class="mx-5" v-if="page == 0" />
          <Household class="mx-5" v-if="page == 1" />
          <Fashion class="mx-5" v-if="page == 2" />
          <Elektronik class="mx-5" v-if="page == 3" />
          <Gadget class="mx-5" v-if="page == 4" />
          <Mainan class="mx-5" v-if="page == 5" />
          <Babies class="mx-5" v-if="page == 6" />
          <div v-if="findData == null">
            <v-container>
              <v-row align="center" justify="center">
                <v-icon size="80">fas fa-circle-notch fa-spin</v-icon>
              </v-row>
            </v-container>
          </div>
          <div class="my-3">
            <v-chip v-if="page == 7" class="ma-2" color="cyan" label text-color="white">
              "{{ pencarian }}"
              <v-icon @click="page = 0" class="mx-1" small>mdi-close</v-icon>
            </v-chip>
          </div>
          <v-container v-if="page == 7 && findData != null">
            <v-row>
              <v-flex v-for="item in findData" :key="item.title" xs4 md3 lg2>
                <div>
                  <v-card shaped raised class="mx-1 mb-1">
                    <v-img
                      @click="detailProduct(item.idbarang)"
                      :src="getImageUrl(item.gambar)"
                      class="white--text align-end"
                      width="auto"
                      max-height="100"
                      centered
                    ></v-img>

                    <v-card-actions>
                      <v-row>
                        <v-col>
                          <p class="item-title">
                            <b>{{ item.nama_item }}</b>
                          </p>
                          <p class="item-price">
                            <b>{{ item.harga | currency }}</b>
                          </p>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-flex>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-flex>
    <!-- <Chat /> -->
    <!-- LIST MENU -->
  </div>
</template>

<script>
// import Chat from "../components/Chat";
import All from "../components/Barang/All";
import Household from "../components/Barang/Household";
import Fashion from "../components/Barang/Fashion";
import Elektronik from "../components/Barang/Elektronik";
import Gadget from "../components/Barang/Gadget";
import Mainan from "../components/Barang/Mainan";
import Babies from "../components/Barang/Babies";

export default {
  components: {
    All,
    Household,
    Fashion,
    Elektronik,
    Gadget,
    Mainan,
    Babies
    // Chat
  },
  data: () => ({
    pencarian: null,
    dataUser: [],
    findData: [],
    token: localStorage.getItem("token"),

    page: localStorage.getItem("pages"),
    items: [
      { text: "Rumah Tangga", icon: "fas fa-home", page: 1 },
      { text: "Fashion", icon: "fas fa-tshirt", page: 2 },
      { text: "Elektronik", icon: "fas fa-tv", page: 3 },
      { text: "Gadget", icon: "fas fa-tablet-alt", page: 4 },
      { text: "Mainan", icon: "fas fa-robot", page: 5 },
      { text: "Kebutuhan Anak", icon: "fas fa-child", page: 6 }
    ],
    cartHeader: 0,
    userid: localStorage.getItem("user_id"),
    idkeranjang: localStorage.getItem("idkeranjang")
  }),
  mounted() {
    this.getCart();
    this.getDataUser();
  },

  methods: {
    goTo(e) {
      this.$router.push(e);
    },
    show(id) {
      this.page = id;
    },
    getDataUser() {
      this.overlay = true;
      fetch("http://meridinet.saebo.id:2082/Login/api/ViewUser/" + this.userid)
        .then(response => response.json())
        .then(data => {
          this.dataUser = data;
        });
    },
    getCart() {
      this.overlay = true;
      fetch(
        "http://meridinet.saebo.id:2082/Login/api/checkoutpro/" +
          this.idkeranjang +
          "/1000"
      )
        .then(response => response.json())
        .then(data => {
          if (data.keranjang != null) {
            this.carts = data.keranjang;
            var x = this.carts.length;
            if (x > 0) {
              this.cartHeader = x;

              this.notifCart = x;
            } else {
              this.cartHeader = 0;
            }

            this.overlay = false;
          } else {
            this.cartHeader = 0;
            this.overlay = false;
          }
        });
    },
    getImageUrl(e) {
      var x = e.replace(/\.[^/.]+$/, "");
      return `http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/${x}`;
    },
    find() {
      this.page = 7;
      fetch("http://meridinet.saebo.id:2082/Login/api/barang/" + this.pencarian)
        .then(response => response.json())
        .then(data => {
          if (data != "Not Found") {
            this.findData = data;
          } else {
            console.log("");
          }
        });
    }
  }
};
</script>
<style scoped>
.verified-user {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 60%;
  letter-spacing: -0.2px;
  margin-top: -15%;
  word-spacing: 2px;
  color: #838383;
  font-weight: normal;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.nama-user {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 75%;
  letter-spacing: -0.2px;
  word-spacing: 2px;
  color: #000000;
  font-weight: normal;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
}
.item-toko {
  font-size: 85%;
  width: 150px;
  /* height: 10px; */
  /* overflow: hidden; */
  white-space: wrap;
  text-overflow: ellipsis;
  margin-bottom: 0% !important;
}
.item-title {
  font-size: 90%;
  width: 100%;
  height: 40px;
  overflow: hidden;
  white-space: wrap;
  text-overflow: ellipsis;
  margin-bottom: 0% !important;
}
.item-price {
  color: red;
  margin-bottom: -10% !important;
  font-size: 85%;
}
.all-produk {
  padding: 0px !important;
  margin-top: 5px;
}
@media only screen and (max-width: 600px) {
  .item-title {
    font-size: 85%;
    width: 100px;
    height: 40px;
    overflow: hidden;
    white-space: wrap;
    text-overflow: ellipsis;
    margin-bottom: 0% !important;
  }
  .item-price {
    color: red;
    margin-bottom: 0% !important;
    font-size: 85%;
  }
  .all-produk {
    padding: 0px !important;
    margin-top: 5px;
  }
}
</style>
